<template>
  <div class="container mt-5">
    <h2>Login</h2>
    <form @submit.prevent="login">
      <div class="mb-3 col-md-6">
        <label for="userId" class="form-label">E-mail</label>
        <input
          type="text"
          v-model="email"
          class="form-control"
          id="userId"
          required
        />
      </div>
      <div class="mb-3 col-md-6">
        <label for="password" class="form-label">Password</label>
        <input
          type="password"
          v-model="password"
          class="form-control"
          id="password"
          required
        />
      </div>
      <button type="submit" class="btn btn-dark">Login</button>
      <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
    </form>
    <p class="mt-3">
      Don't have an account?
      <span class="text-primary" role="button" @click="goToSignup"><u>Sign up now!</u></span>
    </p>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "@/globals";
import { usePageMeta } from '@/composables/usePageMeta';

export default {
  name: "LoginCOmponent",
  props: {
    redirectPage: {
      type: Boolean,
      default: true,
    },
    callFromModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
    };
  },
  mounted() {
    usePageMeta({
      title: "Login | Nilkhet Books",
      description: "Place for quality books and stationery items",
      image: "",
    });
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(`${BASE_URL}/api/auth/login`, {
          email: this.email,
          password: this.password,
        });
        const user = {
          email: this.email,
        };
        const token = response.data.token;
        const passwordResetNeeded = response.data.passwordResetNeeded;
        this.$store.dispatch("login", { user, token, passwordResetNeeded });
        if (this.redirectPage) {
          setTimeout(() => {
            this.$router.push("/");
          }, 500);
        }
        if (this.callFromModal) {
          this.closeModal();
        }
      } catch (error) {
        this.errorMessage = "Login failed. Please check your credentials.";
      }
    },
    goToSignup() {
      this.closeModal()
      this.$router.push('/signup')
    },
    closeModal() {
      this.email = "";
      this.password = "";
      this.$emit("closeModal");
    },
  },
};
</script>
